<template>
  <div>
    <HTMLHeader></HTMLHeader>
    <div class="wrapper">
      <HTMLMenu></HTMLMenu>

      <div class="content">
        <div class="container">
          <div class="floating-buttons">
            <button style="width: 100%; margin: 0 5px" class="fl-button" type="button" v-on:click="setupDownload()"><i class="fa fa-download"><span style="font-family: 'Montserrat'; padding-left: 5px; font-size: 15px;">Kártyaolvasó illesztő letöltése</span></i></button>
          </div>
          <h1>Üdvözöljük</h1>
          <div class="normal-text">
            A rendszer használatához válasszon a bal oldali menüpontok közül!
          </div>
          <h2>Önállóan üzemelő nciom alapú beléptető rendszerek (kizárólag egyetemi hálózatból érhetők el)</h2>
          <table class="list">
            <thead>
              <tr>
                <th>Név</th>
                <th>Cím</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>D711</td>
                <td>d711-belepteto.sze.hu</td>
                <td><a class="small-button" href="http://d711-belepteto.sze.hu" target="_blank"><i style="font-size: 18px; cursor: pointer;" class="fas fa-forward"></i></a></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>
    <HTMLFooter></HTMLFooter>
  </div>
</template>
<script>
export default {
  mounted: function() {
  },
  methods: {
    setupDownload () {
      window.open('https://kmr.sze.hu/setup.exe');
    }
  }
}
</script>




// WEBPACK FOOTER //
// home.vue?b57ec57a